<template>
  <reminder-table resource-name="house" :resource-id="houseData.id" @refetch-data="emit('refetch-data')" />
</template>

<script>
import { useState } from 'vuex-composition-helpers'
import ReminderTable from '@/components/reminders-table/ReminderTable.vue'

export default {
  components: { ReminderTable },
  setup(props, { emit }) {
    const { houseData } = useState('staff', ['houseData'])

    return {
      emit,
      houseData,
    }
  },
}
</script>
